import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';

const globalColorsAction = createDefaultActionDefinition(
  StylesDerivedNativeActions.globalColorsStyles,
);

export default globalColorsAction;
